// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Container, Row, Col } from 'Components/Grid';
import RichText from 'Components/RichText';
import styles from './styles.scss';
import { getColorTypeFromClassName, hasDarkBackground } from 'Utils/getColor';
import ConsumptionData from 'Components/ConsumptionData';
import Typography, { headlinePropTypes } from 'Components/Typography';
const cx = classNames.bind(styles);

const TextBlock = ({
  background = 'light',
  consumptionText,
  deeplinkId,
  headline,
  id,
  bodyText,
  children,
}) => (
  <>
    <div id={deeplinkId || id} className={cx(styles.contentText, { [background]: true })}>
      <Container>
        <Row align="center">
          <Col cols={12} m={10} l={8}>
            {headline && (
              <Typography.Headline
                className={cx(styles.headline, {
                  [styles.overwritep]: hasDarkBackground(background),
                })}
                additionalAriaLabelText={consumptionText}
                {...headline}
              />
            )}
            {bodyText && (
              <RichText
                content={bodyText}
                hasDarkBackground={hasDarkBackground(background)}
                className={styles.noPaddingBottom}
              />
            )}
            {children}
          </Col>
        </Row>
      </Container>
    </div>

    {consumptionText && <ConsumptionData consumptionText={[consumptionText]} ariaHidden={true} colorType={getColorTypeFromClassName(background)} />}
  </>
);

TextBlock.propTypes = {
  background: PropTypes.string, //PropTypes.oneOf(['dark', 'medium', 'light']), // default medium
  consumptionText: PropTypes.string,
  deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  headline: PropTypes.shape(headlinePropTypes),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bodyText: PropTypes.string,
  children: PropTypes.node,
};

export default TextBlock;
